<template>
  <div>
    <h1>{{ $t('promotion') }}</h1>
    <div class="pb-3">
      <v-breadcrumbs :items="breadcrumbItems">
        <template #item="props">
          <a :class="[props.item.disabled && 'disabled']" @click="handleClose">{{
            props.item.text.toUpperCase()
          }}</a>
        </template>
      </v-breadcrumbs>
    </div>
    <div class="pt-3">
      <v-btn
        :depressed="tabs == 'promotion-info'"
        :flat="tabs != 'promotion-info'"
        :color="tabs == 'promotion-info' ? 'primary' : 'grey'"
        class="ma-0 mr-1"
        @click="tabs = 'promotion-info'"
        >{{ $t('promotion_info') }}</v-btn
      >
      <v-btn
        :depressed="tabs == 'promotion-items'"
        :flat="tabs != 'promotion-items'"
        :color="tabs == 'promotion-items' ? 'primary' : 'grey'"
        class="ma-0 mr-1"
        :disabled="type === 'add' && tabs === 'promotion-info'"
        @click="tabs = 'promotion-items'"
      >
        {{ $t('promotion_items') }}
      </v-btn>
    </div>

    <div style="border: 2px solid #ff706b" class="pa-2">
      <div v-if="tabs == 'promotion-info'" class="py-3">
        <v-layout wrap>
          <v-flex xs6 class="form-control px-2 pb-3" :class="{ 'has-error': errors.has('name') }">
            <span>{{ $t('Name') }} </span><span class="red--text">*</span>
            <v-text-field
              v-model="input.name"
              v-validate="'required'"
              flat
              outline
              solo
              :placeholder="$t('Name')"
              name="name"
              class="default-input-textfield"
              :data-vv-as="$t('Name')"
              hide-details
            ></v-text-field>
            <p v-if="errors.has('name')" class="text-error pt-2">{{ errors.first('name') }}</p>
          </v-flex>
          <v-flex xs6 class="px-2 pb-3">
            <v-layout wrap>
              <v-flex
                xs12
                sm6
                class="form-control pr-1 custom-datepicker-input"
                :class="{ 'has-error': errors.has('startTime') }"
              >
                <span class="pb-1">วันที่เริ่มต้น </span><span class="red--text">*</span>
                <DatepickerCustomDialog v-model="input.start_date">
                  <template #default="{ computedDate }">
                    <v-text-field
                      v-validate="'required'"
                      class="custom-datepicker-input"
                      outline
                      name="startTime"
                      placeholder="DD/MM/YYYY"
                      readonly
                      :value="computedDate"
                      hide-details
                      single-line
                      prepend-inner-icon="event"
                      style="color: #000"
                      :data-vv-as="'วันที่เริ่มต้น'"
                    ></v-text-field>
                  </template>
                </DatepickerCustomDialog>
                <p v-if="errors.has('startTime')" class="text-error pt-2">
                  {{ errors.first('startTime') }}
                </p>
              </v-flex>
              <v-flex
                xs12
                sm6
                class="form-control custom-datepicker-input pl-1"
                :class="{ 'has-error': errors.has('endTime') }"
              >
                <span class="pb-1">วันที่สิ้นสุด </span><span class="red--text">*</span>
                <DatepickerCustomDialog v-model="input.end_date">
                  <template #default="{ computedDate }">
                    <v-text-field
                      v-validate="'required'"
                      class="custom-datepicker-input"
                      outline
                      name="endTime"
                      placeholder="DD/MM/YYYY"
                      readonly
                      :value="computedDate"
                      hide-details
                      single-line
                      prepend-inner-icon="event"
                      style="color: #000"
                      :data-vv-as="'วันที่สิ้นสุด'"
                    ></v-text-field>
                  </template>
                </DatepickerCustomDialog>
                <p v-if="errors.has('endTime')" class="text-error pt-2">
                  {{ errors.first('endTime') }}
                </p>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex
            xs12
            class="form-control px-2 py-2 pb-3"
            :class="{ 'has-error': errors.has('promotionType') }"
          >
            <span>Promotion Type </span><span class="red--text">*</span>
            <v-radio-group
              v-model="input.promotion_type"
              v-validate="'required'"
              color="primary"
              row
              class="text-xs-center mt-1"
              name="promotionType"
              hide-details
              :data-vv-as="'Promotion Type'"
            >
              <v-radio
                color="primary"
                label="ซื้อสินค้าคู่กัน"
                :value="'ซื้อสินค้าคู่กัน'"
              ></v-radio>
              <v-radio color="primary" label="ซื้อสินค้าครบ" :value="'ซื้อสินค้าครบ'"></v-radio>
            </v-radio-group>
            <p v-if="errors.has('promotionType')" class="text-error">
              {{ errors.first('promotionType') }}
            </p>
          </v-flex>
          <v-flex
            xs6
            class="form-control px-2"
            :class="{ 'has-error': errors.has('departmentStore') }"
          >
            <span>ห้าง </span><span class="red--text">*</span>
            <div class="pt-1">
              <v-select
                v-model="input.department_store"
                v-validate="'required'"
                flat
                outline
                full-width
                :items="departmentStoreOptions"
                solo
                name="departmentStore"
                placeholder="ห้าง"
                :data-vv-as="'ห้าง'"
                hide-details
              ></v-select>
              <p v-if="errors.has('departmentStore')" class="text-error">
                {{ errors.first('departmentStore') }}
              </p>
            </div>
          </v-flex>
          <v-flex xs6 class="form-control px-2" :class="{ 'has-error': errors.has('branch') }">
            <span>สาขา </span><span class="red--text">*</span>
            <div class="pt-1">
              <v-select
                v-model="input.branch"
                v-validate="'required'"
                flat
                outline
                full-width
                :items="branchOptions"
                solo
                name="branch"
                placeholder="สาขา"
                :data-vv-as="'สาขา'"
                hide-details
              ></v-select>
              <span v-if="errors.has('branch')" class="text-error">{{
                errors.first('branch')
              }}</span>
            </div>
          </v-flex>

          <v-flex xs12 class="pt-3 text-xs-center">
            <v-btn outline color="grey" @click="handleClose">{{ $t('cancel') }}</v-btn>
            <v-btn color="primary" depressed @click="handleSaveData">{{ $t('Save') }}</v-btn>
          </v-flex>
        </v-layout>
      </div>

      <div v-if="tabs == 'promotion-items'" class="pa-2">
        <PromotionItems v-if="promotionId" :promotion-id="promotionId"></PromotionItems>
      </div>
    </div>
  </div>
</template>

<script>
import toaCrmApi from '@/api/toa-crm'
import DatepickerCustomDialog from '@/components/elements/DatepickerCustomDialog.vue'
import { mapGetters } from 'vuex'
import moment from 'moment'
import PromotionItems from './PromotionItems'

export default {
  components: {
    DatepickerCustomDialog,
    PromotionItems
  },
  props: ['value', 'type'],
  data() {
    return {
      tabs: 'promotion-info',
      promotionId: null,
      input: {
        name: '',
        start_date: '',
        end_date: '',
        promotion_type: 'ซื้อสินค้าคู่กัน',
        department_store: 'ทุกห้าง',
        branch: 'ทุกสาขา'
      },
      breadcrumbItems: [
        {
          text: this.$t('promotion'),
          disabled: false,
          href: 'patient-history'
        },
        {
          text: this.$t('promotion_info'),
          disabled: true,
          href: '#'
        }
      ]
    }
  },
  computed: {
    ...mapGetters(['selectedBot']),
    moment() {
      return moment
    },
    branchMasterData() {
      return this.$store.state.toacrmbranch
    },
    departmentStoreOptions() {
      let options = ['ทุกห้าง']
      if (this.branchMasterData) {
        this.branchMasterData.forEach((el) => {
          if (![...options].includes(el.department_store)) {
            options.push(el.department_store)
          }
        })
      }
      return options
    },
    branchOptions() {
      let options = ['ทุกสาขา']
      if (this.branchMasterData && this.input.department_store) {
        const tempOptions = this.branchMasterData.filter((el) => {
          return el.department_store === this.input.department_store
        })

        tempOptions.forEach((el) => {
          if (![...options].includes(el.branch)) {
            options.push(el.branch)
          }
        })
      }

      return options
    }
  },
  mounted() {
    if (this.value) {
      this.promotionId = this.value.id
      this.input.name = this.value.name
      this.input.start_date = this.value.start_date
        ? moment(this.value.start_date).format('YYYY-MM-DD')
        : ''
      this.input.end_date = this.value.end_date
        ? moment(this.value.end_date).format('YYYY-MM-DD')
        : ''
      this.input.promotion_type = this.value.promotion_type

      if (this.value.department_store) {
        this.input.department_store = this.value.department_store
      }

      if (this.value.branch) {
        this.input.branch = this.value.branch
      }
    }
  },
  methods: {
    async handleSaveData() {
      const vm = this

      let result = await vm.$validator.validateAll()
      if (!result) {
        vm.goToErrorInput()
        return false
      }

      let data = {
        name: vm.input.name,
        start_date: moment(vm.input.start_date).format('YYYY-MM-DD'),
        end_date: moment(vm.input.end_date).format('YYYY-MM-DD'),
        promotion_type: vm.input.promotion_type,
        page_id: vm.selectedBot.pageid,
        department_store:
          vm.input.department_store === 'ทุกห้าง' ? null : vm.input.department_store,
        branch: vm.input.branch === 'ทุกสาขา' ? null : vm.input.branch
      }

      let response
      if (vm.type === 'add') {
        Object.assign(data, { cordition: [] })
        response = await vm.createPromotion(data)
      } else {
        Object.assign(data, { promotionId: vm.value.id })
        response = await vm.updatePromotion(data)
      }

      if (response && response.status === 200) {
        await vm.$swal.fire({
          text: 'สำเร็จ',
          type: 'success'
        })

        if (vm.type === 'add') {
          const promotionId = response.data.data && response.data.data[0].id
          vm.promotionId = promotionId
          vm.tabs = 'promotion-items'
        } else {
          vm.$emit('success')
        }
      }
    },
    async createPromotion(payload) {
      const vm = this
      try {
        vm.$store.dispatch('loading')
        const response = await toaCrmApi.postPromotion({ data: payload })
        vm.$store.dispatch('loading')

        if (response) {
          return response
        } else {
          return null
        }
      } catch (error) {
        console.error(error)
        vm.$store.dispatch('loading')
        return null
      }
    },
    async updatePromotion(payload) {
      const vm = this
      try {
        vm.$store.dispatch('loading')
        const response = await toaCrmApi.patchPromotion({ data: payload })
        vm.$store.dispatch('loading')

        if (response) {
          return response
        } else {
          return null
        }
      } catch (error) {
        console.error(error)
        vm.$store.dispatch('loading')
        return null
      }
    },
    handleClose() {
      this.input = {
        name: '',
        start_date: '',
        end_date: '',
        promotion_type: 'ซื้อสินค้าคู่กัน',
        department_store: '',
        branch: ''
      }
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
tr > td {
  white-space: nowrap;
}
.disabled {
  color: grey;
  pointer-events: none;
}
</style>



// WEBPACK FOOTER //
// src/components/view/template/toacrm/Promotion/PromotionManage.vue